export default __webpack_public_path__ + "static/media/Eye_bg.0aabb7a9.svg";